export const SINGLE_SERIES_FUND_CHART_OPTIONS = {
    series: [{ type: 'area' }],
    xAxis: {
        tickAmount: 5,
    },
};
